import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { ArrowLeft, Shield } from 'lucide-react';
import { mockData } from '../data/mock';

const FAQPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Shield className="h-8 w-8 text-blue-600 mr-3" />
              <h1 className="text-xl font-semibold text-gray-900">
                Legacy Property Association
              </h1>
            </div>
            <Button variant="outline" size="sm" onClick={() => navigate('/')}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </div>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-slate-800 mb-6">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Common questions about our Private Member Association and services.
          </p>
        </div>

        <div className="space-y-6">
          {mockData.faqs.map((faq, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-8">
                <h3 className="text-xl font-semibold text-slate-800 mb-4">{faq.question}</h3>
                <p className="text-slate-600 leading-relaxed text-lg">{faq.answer}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <h3 className="text-xl font-semibold text-slate-800 mb-4">Still have questions?</h3>
          <p className="text-slate-600 mb-6">
            Our member support team is here to help with any additional questions about Legacy Property Association.
          </p>
          <div className="space-y-4">
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                onClick={() => window.location.href = 'mailto:hello@legacypropertyassociation.com'} 
                className="bg-blue-600 hover:bg-blue-700"
              >
                Email Support
              </Button>
              <Button 
                onClick={() => navigate('/')} 
                variant="outline"
              >
                Contact Us
              </Button>
            </div>
            <div className="text-sm text-slate-500">
              <p>Email: hello@legacypropertyassociation.com</p>
              <p>Phone: (312) 555-LEGACY</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;